import React from "react";
import { useFormikContext } from "formik";
import FormField from "../VendorOnboarding/FormField";

const Step8 = () => {
  const { values } = useFormikContext();

  return (
    <div className="w-full">
      <h3 className="text-[#242424] font-medium mb-2">
        Are there any pets we should be aware of when entering the property?
      </h3>
      <h4 className="text-[#595959] font-medium mb-4">
        You don't need to include pets that are caged, tanked, or fully confined
        ( like fish, birds, or reptiles in enclosures).
      </h4>

      <FormField
        label=""
        name="has_pets"
        type="radio"
        options={[
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ]}
      />

      {values?.has_pets === true && (
        <div className="mt-4">
          <FormField
            label="Tell us more?"
            name="pet_details"
            type="textarea"
            placeholder="Please provide details about your pets..."
            className="min-h-[120px]"
          />
        </div>
      )}
    </div>
  );
};

export default Step8;
